import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMultiPageForm as GetMultiPageFormQuery,
    GetMultiPageFormVariables as GetMultiPageFormVariables,
    MultiPageFormFragment,
} from 'nutshell-graphql-types';

import GET_MULTI_PAGE_FORM from '../queries/get-multi-page-form.graphql';

export const useGetMultiPageForm = (input: {
    formId?: string | null | undefined;
    formSlug?: string | null | undefined;
}): {
    form: MultiPageFormFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetMultiPageFormQuery,
        GetMultiPageFormVariables
    >(GET_MULTI_PAGE_FORM, {
        variables: {
            formId: input.formId,
            formSlug: input.formSlug,
        },
        skip: !input.formId && !input.formSlug,
    });

    const form = data ? data.form : null;

    return {
        form,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
